(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aeco-pond-health-advisor"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-pond-advisor]').forEach(function (root) {
    if (root.dataset.bound === 'true') return;
    root.dataset.bound = 'true';

    var Engine = window.PondAdvisorEngine;
    var form = root.querySelector('[data-advisor-form]');
    var live = root.querySelector('[data-live]');
    var liveList = root.querySelector('[data-live-list]');
    var report = root.querySelector('[data-report]');
    var progress = root.querySelector('[data-progressbar]');
    var endpoint = (root.dataset.waitlistEndpoint || '').trim();
    var shopAll = root.dataset.shopall || '/collections/all';
    var carePathsMeta = readJSON(root.querySelector('[data-care-paths-config]')) || {};
    var catalog = readJSON(root.querySelector('[data-advisor-catalog]')) || [];

    var lastInput = null, lastReport = null, selectedPath = null, submitting = false, pondGallons = null;
    var removedPlan = {};

    function readJSON(el) { if (!el) return null; try { return JSON.parse(el.textContent); } catch (e) { return null; } }
    function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
    // NB: use querySelector, not form.elements[name] — a field named "length" would
    // collide with the collection's own .length property and return a number.
    function fieldEl(name) { return form.querySelector('[name="' + name + '"]'); }
    function fieldVal(name) { var el = fieldEl(name); return el ? String(el.value).trim() : ''; }
    function collectChecked(name) { var out = []; form.querySelectorAll('input[name="' + name + '"]:checked').forEach(function (c) { out.push(c.value); }); return out; }

    function collectInput() {
      return {
        length: fieldVal('length'), width: fieldVal('width'), depth: fieldVal('depth'),
        knownGallons: fieldVal('knownGallons'), fishLoad: fieldVal('fishLoad'), sun: fieldVal('sun'), season: fieldVal('season'),
        filtration: fieldVal('filtration'),
        ph: fieldVal('ph'), ammonia: fieldVal('ammonia'), nitrite: fieldVal('nitrite'), nitrate: fieldVal('nitrate'),
        kh: fieldVal('kh'), oxygen: fieldVal('oxygen'), waterTemp: fieldVal('waterTemp'),
        chlorine: fieldVal('chlorine'), testMethod: fieldVal('testMethod'),
        symptoms: collectChecked('symptoms'), maintenanceGoals: collectChecked('maintenanceGoals')
      };
    }

    // ---- Status pill helper (icon + label + color; never color alone) ----
    var STATUS_ICON = { healthy: '✓', monitor: '○', concerning: '▲', critical: '✕', missing: '–', unable: '?' };
    var STATUS_TEXT = { healthy: 'Healthy', monitor: 'Monitor', concerning: 'Concerning', critical: 'Critical', missing: 'Missing', unable: 'Unable to assess' };
    function pill(status) {
      return '<span class="pha-pill" data-status="' + esc(status) + '"><span class="pha-ic" aria-hidden="true">' + STATUS_ICON[status] + '</span>' + esc(STATUS_TEXT[status]) + '</span>';
    }

    // ---- Wizard nav (2 form steps) ----
    var steps = Array.prototype.slice.call(form.querySelectorAll('fieldset[data-step]'));
    function showStep(n) {
      steps.forEach(function (fs) { fs.hidden = parseInt(fs.dataset.step, 10) !== n; });
      live.hidden = n !== 2;
      report.hidden = true;
      form.hidden = false;
      setStage(n);
      if (n === 2) updateLive();
      focusFirst(steps[n - 1]);
      scrollToTop();
    }
    function currentStep() { for (var i = 0; i < steps.length; i++) { if (!steps[i].hidden) return parseInt(steps[i].dataset.step, 10); } return 1; }
    function focusFirst(fs) { if (!fs) return; var el = fs.querySelector('legend'); if (el) { el.setAttribute('tabindex', '-1'); el.focus(); } }
    function scrollToTop() { var t = progress.getBoundingClientRect().top + window.pageYOffset - 80; if (Math.abs(window.pageYOffset - t) > 120) window.scrollTo({ top: Math.max(0, t), behavior: 'smooth' }); }

    // ---- Progress bar ----
    function setStage(stage) {
      Array.prototype.slice.call(progress.children).forEach(function (li) {
        var s = parseInt(li.dataset.stage, 10);
        li.classList.toggle('is-current', s === stage);
        li.classList.toggle('is-complete', s < stage);
        var st = li.querySelector('.pha-pb-state');
        if (st) st.textContent = s === stage ? 'current step' : (s < stage ? 'completed' : 'upcoming');
        if (s === stage) li.setAttribute('aria-current', 'step'); else li.removeAttribute('aria-current');
        // stages 3-5 clickable only after a report exists (safe backward/section nav)
        var clickable = lastReport && s >= 3;
        li.dataset.clickable = clickable ? 'true' : 'false';
        li.setAttribute('role', clickable ? 'button' : 'listitem');
        if (clickable) li.setAttribute('tabindex', '0'); else li.removeAttribute('tabindex');
      });
    }
    progress.addEventListener('click', onStageActivate);
    progress.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { onStageActivate(e); } });
    function onStageActivate(e) {
      var li = e.target.closest('[data-stage]'); if (!li || li.dataset.clickable !== 'true') return;
      e.preventDefault();
      var s = parseInt(li.dataset.stage, 10);
      var anchor = { 3: '[data-sec-analysis]', 4: '[data-sec-reco]', 5: '[data-sec-plan]' }[s];
      var el = report.querySelector(anchor);
      if (el) { setStage(s); el.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    }

    form.addEventListener('click', function (e) {
      var t = e.target.closest('[data-next],[data-back],[data-analyze]');
      if (!t) return;
      if (t.hasAttribute('data-next')) showStep(2);
      else if (t.hasAttribute('data-back')) showStep(1);
      else if (t.hasAttribute('data-analyze')) runAnalysis();
    });

    // ---- Live gallons + reading feedback (Step 2) ----
    var gallonsReadout = form.querySelector('[data-gallons-readout]');
    ['length', 'width', 'depth', 'knownGallons'].forEach(function (n) { var el = fieldEl(n); if (el) el.addEventListener('input', updateGallonsReadout); });
    form.querySelectorAll('[data-reading]').forEach(function (el) {
      el.addEventListener('input', updateLive);
      el.addEventListener('input', function () { clampNonNegative(el); });
    });
    function clampNonNegative(el) { if (el.value !== '' && parseFloat(el.value) < 0) el.value = '0'; }
    function updateGallonsReadout() {
      if (!gallonsReadout || !Engine) return;
      var g = Engine.estimateGallons(collectInput());
      gallonsReadout.innerHTML = g.gallons ? 'Estimated volume: <strong>' + g.gallons.toLocaleString() + ' gal</strong>' + (g.estimated ? ' (from dimensions)' : '') : '';
    }
    function updateLive() {
      if (!Engine || !Engine.computeReadingStatuses) return;
      var statuses = Engine.computeReadingStatuses(collectInput());
      liveList.innerHTML = statuses.map(function (s) {
        var val = s.entered ? esc(s.value + (s.unit ? ' ' + s.unit : '')) : 'not entered';
        return '<div class="pha-live-item" data-status="' + esc(s.status) + '">' +
          '<div class="pha-li-top"><span class="pha-li-name">' + esc(s.name) + '</span>' + pill(s.status) + '</div>' +
          '<div class="pha-li-val">' + val + ' &middot; target ' + esc(s.target || 'context') + '</div>' +
          (s.entered ? '<div class="pha-li-note">' + esc(s.explanation) + (s.retest ? ' <b>Retest to confirm.</b>' : '') + '</div>' : '') +
          '</div>';
      }).join('');
    }

    // ---- Product resolution (EasyPro-first + size-aware; Shopify is the only source) ----
    function isEasyPro(p) { return String(p.vendor || '').toLowerCase().replace(/[^a-z]/g, '').indexOf('easypro') > -1; }
    // Max pond gallons a product is rated for: structured metafield first, then the
    // free-text pond-size field ("up to 5,000 gal"). null = size-agnostic (never guessed).
    function ratedGallons(p) {
      var m = parseInt(p.maxGallons, 10);
      if (!isNaN(m) && m > 0) return m;
      var t = String(p.pondSizeText || '').replace(/,/g, '');
      var mm = t.match(/(\d{2,7})\s*(?:us\s*)?gal/i);
      return mm ? parseInt(mm[1], 10) : null;
    }
    function matchProducts(category, limit) {
      var tag = 'advisor:' + category.key, out = [];
      catalog.forEach(function (p) {
        var tags = (p.tags || []).map(function (x) { return String(x).toLowerCase(); });
        var hit = tags.indexOf(tag) > -1;
        if (!hit && p.type && category.type && p.type === category.type) hit = (category.keywords || []).some(function (k) { return (p.title || '').toLowerCase().indexOf(k) > -1; });
        if (!hit) hit = (category.keywords || []).some(function (k) { return (p.title || '').toLowerCase().indexOf(k) > -1; });
        if (hit) out.push(p);
      });
      out.sort(function (a, b) {
        // When we know the pond volume, rank by size fit: right-sized first,
        // size-agnostic next, undersized last (only affects rated products).
        if (pondGallons) {
          var ra = ratedGallons(a), rb = ratedGallons(b);
          var rank = function (r) { return r == null ? 1 : (r >= pondGallons ? 0 : 2); };
          var da = rank(ra), db = rank(rb);
          if (da !== db) return da - db;
          if (da === 0 && ra !== rb) return ra - rb; // both fit: smallest (right-sized) first
        }
        var ep = (isEasyPro(b) ? 1 : 0) - (isEasyPro(a) ? 1 : 0); if (ep !== 0) return ep;
        return (b.available === true ? 1 : 0) - (a.available === true ? 1 : 0);
      });
      return out.slice(0, limit || 1);
    }
    function productCardHTML(category, reason, recurring) {
      var p = matchProducts(category, 1)[0];
      var freq = recurring ? '<span class="pha-freq-badge">Recurring</span>' : '<span class="pha-freq-badge">One-time</span>';
      if (!p) {
        // No verified product — neutral category, never fabricated.
        return '<a class="pha-product pha-product--link" href="' + esc(shopAll) + '">' +
          '<div class="pha-p-badges"><span class="pha-p-cat">' + esc(category.label) + '</span>' + freq + '</div>' +
          '<span class="pha-p-title">Browse ' + esc(category.label.toLowerCase()) + '</span>' +
          '<span class="pha-p-why"><b>Why A-eco suggests this:</b> ' + esc(reason) + '</span>' +
          '<span class="pha-p-caution">We don’t have a matching product to show right now — browse the category.</span></a>';
      }
      var img = p.image ? '<img src="' + esc(p.image) + '" alt="' + esc(p.title) + '" loading="lazy" width="360" height="150">' : '';
      var meta = p.available === true ? '<span class="pha-p-meta">' + esc(p.price) + '</span>' : '<span class="pha-p-meta pha-p-oos">Currently unavailable</span>';
      var ep = isEasyPro(p) ? '<span class="pha-ep-badge">EasyPro</span>' : '';
      var rated = ratedGallons(p), caution;
      if (rated && pondGallons && pondGallons > rated) caution = 'Rated for ponds up to ' + rated.toLocaleString() + ' gal — your pond (~' + pondGallons.toLocaleString() + ' gal) may need a larger size. Follow the product label.';
      else if (rated) caution = 'Rated for ponds up to ' + rated.toLocaleString() + ' gal. Confirm the fit and follow the product label.';
      else caution = 'Confirm the size suits your pond and follow the product label before dosing.';
      return '<a class="pha-product" href="' + esc(p.url) + '">' + img +
        '<div class="pha-p-badges"><span class="pha-p-cat">' + esc(category.label) + '</span>' + ep + freq + '</div>' +
        '<span class="pha-p-title">' + esc(p.title) + '</span>' + meta +
        '<span class="pha-p-why"><b>Why A-eco recommends this:</b> ' + esc(reason) + '</span>' +
        '<span class="pha-p-caution">' + esc(caution) + '</span></a>';
    }

    // ---- Analysis + report ----
    function runAnalysis() {
      if (!Engine || !Engine.buildReport) return;
      lastInput = collectInput();
      lastReport = Engine.buildReport(lastInput);
      pondGallons = lastReport.gallons;
      removedPlan = {};
      selectedPath = lastReport.subscription && lastReport.subscription.tier;
      renderReport(lastReport);
      form.hidden = true; live.hidden = true; report.hidden = false;
      setStage(3);
      report.focus();
      report.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    function renderReport(r) {
      report.innerHTML =
        analysisHTML(r) +
        recommendationsHTML(r) +
        planHTML(r) +
        '<div class="pha-block"><button type="button" class="ae-button ae-button--ghost pha-restart" data-restart>Start over</button> ' +
        '<button type="button" class="ae-button ae-button--ghost" data-edit>Back to my answers</button></div>';
      wireReport();
    }

    // Stage 3 — Analysis (score, categories, confidence, statuses)
    function analysisHTML(r) {
      var sc = r.score, conf = r.confidence;
      var gauge;
      if (sc.overall === null) {
        gauge = '<div class="pha-score pha-score--noinfo"><div class="pha-gauge" style="--v:0"><span class="pha-gauge__num"><b>—</b><span>no score</span></span></div>' +
          '<div class="pha-score__meta"><p class="pha-score__label">' + esc(sc.label) + '</p>' +
          '<p class="pha-score__note">Enter a few core readings (like pH and ammonia) and your pond size for an educational score.</p></div></div>';
      } else {
        gauge = '<div class="pha-score"><div class="pha-gauge" style="--v:' + sc.overall + '"><span class="pha-gauge__num"><b>' + sc.overall + '</b><span>out of 100</span></span></div>' +
          '<div class="pha-score__meta"><p class="pha-score__label">' + esc(sc.label) + '</p>' +
          '<p class="pha-score__note">This score is an educational estimate based only on what you entered. Missing readings reduce confidence — it is not a scientific or laboratory measurement.</p></div></div>';
      }
      var cats = '<div class="pha-cats">' + sc.categories.map(function (c) {
        return '<div class="pha-cat" data-status="' + esc(c.status) + '"><div class="pha-cat__top"><span class="pha-cat__name">' + esc(c.name) + '</span>' +
          '<span class="pha-cat__score">' + (c.score === null ? '—' : c.score) + '</span></div>' +
          '<p class="pha-cat__exp">' + esc(c.explanation) + '</p>' +
          (c.missing && c.missing.length ? '<p class="pha-cat__miss">Missing: ' + esc(c.missing.join(', ')) + '</p>' : '') + '</div>';
      }).join('') + '</div>';

      var statuses = '<div class="pha-live__list" style="margin-top:6px">' + r.statuses.map(function (s) {
        var val = s.entered ? esc(s.value + (s.unit ? ' ' + s.unit : '')) : 'not entered';
        return '<div class="pha-live-item" data-status="' + esc(s.status) + '"><div class="pha-li-top"><span class="pha-li-name">' + esc(s.name) + '</span>' + pill(s.status) + '</div>' +
          '<div class="pha-li-val">' + val + ' &middot; target ' + esc(s.target || 'context') + '</div>' +
          '<div class="pha-li-note">' + esc(s.explanation) + (s.retest ? ' <b>Retest to confirm.</b>' : '') + (s.affects && s.affects.length ? ' <i>Affects ' + esc(s.affects.join(', ')) + '.</i>' : '') + '</div></div>';
      }).join('') + '</div>';

      var confLabel = { high: 'High confidence', moderate: 'Moderate confidence', low: 'Low confidence', none: 'Not enough information' }[conf.level];
      var confIcon = { high: '✓', moderate: '○', low: '△', none: '–' }[conf.level];
      var confBox = '<div class="pha-block pha-conf" data-sec-conf><h3>How confident is this guidance?</h3>' +
        '<div class="pha-conf__level"><span aria-hidden="true">' + confIcon + '</span>' + esc(confLabel) + '</div>' +
        '<div class="pha-conf__cols"><div><h4>Based on</h4><ul>' + (conf.basedOn.length ? conf.basedOn.map(function (x) { return '<li>' + esc(x) + '</li>'; }).join('') : '<li>—</li>') + '</ul></div>' +
        '<div><h4>Still missing</h4><ul>' + (conf.missing.length ? conf.missing.map(function (x) { return '<li>' + esc(x) + '</li>'; }).join('') : '<li>Nothing major</li>') + '</ul></div></div>' +
        (conf.missing.length ? '<p class="pha-conf__why">Adding these readings would make your recommendations more specific.</p>' : '') +
        (conf.reasons.length ? '<p class="pha-conf__why">' + conf.reasons.map(esc).join(' ') + '</p>' : '') + '</div>';

      return '<div class="pha-report__section" data-sec-analysis>' +
        '<h2 class="pha-r-h">Your Pond Health Report</h2>' +
        '<p class="pha-r-sub">A cautious, educational read of what you entered. It highlights what’s healthy, what to watch, and what’s missing — before any product is mentioned.</p>' +
        '<div class="pha-block">' + gauge + '<div style="margin-top:16px">' + cats + '</div></div>' +
        confBox +
        '<div class="pha-block"><h3>Your readings, in plain language</h3>' + statuses + '</div>' +
        '</div>';
    }

    // Stage 4 — Recommendations (prioritized steps, two paths, justified products)
    function recommendationsHTML(r) {
      var steps = r.steps, urgent = r.urgency.urgent;
      function group(band, title, arr) {
        if (!arr.length) return '';
        return '<div class="pha-prio__group" data-band="' + band + '"><h4>' + esc(title) + '</h4>' + arr.map(function (s) {
          return '<div class="pha-step"><h5>' + esc(s.title) + '</h5><ul>' + s.points.map(function (p) { return '<li>' + esc(p) + '</li>'; }).join('') + '</ul></div>';
        }).join('') + '</div>';
      }
      var prio = '<div class="pha-prio">' + group('first', 'Do this first', steps.doFirst) + group('monitor', 'Then monitor', steps.thenMonitor) + group('long', 'Long-term prevention', steps.longTerm) + '</div>';

      // Justified one-time products
      var prods = '';
      if (r.neededCategories && r.neededCategories.length) {
        prods = '<div class="pha-block"><h3>Products worth considering — only what your results justify</h3>' +
          '<p class="pha-r-sub">Each is tied to something you entered, prioritizing EasyPro where it fits. Prices and availability come straight from our store.</p>' +
          '<div class="pha-products">' + r.neededCategories.map(function (c) { return productCardHTML(c.category, c.reason, false); }).join('') + '</div>' +
          '<p class="pha-note">No product replaces the steps above. If a step alone fixes it, you don’t need the product.</p></div>';
      } else {
        prods = '<div class="pha-block"><h3>No product recommended right now</h3><p class="pha-r-sub">Nothing you entered calls for a treatment purchase. Monitor and retest — that’s the trustworthy move.</p></div>';
      }

      // Two paths
      var fix = '<div class="pha-path ' + (urgent ? 'pha-path--primary' : '') + '">' + (urgent ? '<span class="pha-path__flag">Recommended first</span>' : '') +
        '<h4>Fix My Pond</h4><p>Address the current water-quality items above in order. Correct the environment first; a product only if your results justify it.</p>' +
        '<a class="ae-button ' + (urgent ? 'ae-button--coral' : 'ae-button--ghost') + '" href="#" data-goto="reco">See my priority steps</a></div>';
      var keep = '<div class="pha-path ' + (!urgent ? 'pha-path--primary' : 'pha-path--locked') + '">' + (!urgent ? '<span class="pha-path__flag">Ready for you</span>' : '') +
        '<h4>Keep My Pond Healthy</h4><p>' + (urgent ? 'Stabilize the concerns above before starting a routine plan — a maintenance subscription won’t fix an active water-quality issue.' : 'Your pond is stable enough for a preventative A-eco Seasonal Care Plan tailored to your pond.') + '</p>' +
        '<a class="ae-button ' + (!urgent ? 'ae-button--coral' : 'ae-button--ghost') + '" href="#" data-goto="plan">' + (urgent ? 'Review the plan anyway' : 'Build my seasonal plan') + '</a></div>';

      return '<div class="pha-report__section" data-sec-reco><h2 class="pha-r-h">What to do next</h2>' +
        '<p class="pha-r-sub">Prioritized so you know what matters now versus later. Environmental fixes always come before products.</p>' +
        '<div class="pha-block">' + prio + '</div>' + prods +
        '<div class="pha-block"><h3>Choose your path</h3><div class="pha-paths">' + fix + keep + '</div></div></div>';
    }

    // Stage 5 — Editable A-eco Seasonal Care Plan
    function planHTML(r) {
      var sub = r.subscription, urgent = r.urgency.urgent;
      var intro = urgent
        ? '<p class="pha-plan__intro pha-plan__intro--warn">Resolve the concerns above before starting a routine maintenance plan. Once your water is stable, this plan keeps it that way.</p>'
        : '<p class="pha-plan__intro">Your pond is currently stable enough for a preventative maintenance plan. Here’s an EasyPro-focused plan tailored to your pond — edit it freely.</p>';
      var items = (sub.components || []).map(function (c, i) {
        var key = c.category.key;
        var p = matchProducts(c.category, 1)[0];
        var prod = p
          ? '<span class="pha-plan-prod">' + (isEasyPro(p) ? '<span class="pha-ep-badge">EasyPro</span>' : '') + esc(p.title) + (p.available === true ? ' &middot; ' + esc(p.price) : ' &middot; <em>currently unavailable</em>') + '</span>'
          : '<span class="pha-plan-prod pha-plan-prod--tbd">We’ll match an EasyPro ' + esc(c.category.label.toLowerCase()) + '</span>';
        return '<li class="pha-plan-item" data-plan-key="' + esc(key) + '" data-removed="false">' +
          '<div class="pha-plan-item__head"><span class="pha-plan-cat">' + esc(c.category.label) + '</span><span class="pha-plan-cadence">' + esc(c.cadence) + '</span></div>' +
          prod +
          '<span class="pha-plan-why"><b>Why it’s here:</b> ' + esc(c.reason) + '</span>' +
          '<button type="button" class="pha-plan-remove" data-remove-plan="' + esc(key) + '">Remove from plan</button></li>';
      }).join('');

      var order = ['water_garden', 'serious_koi', 'estate'];
      var tiers = order.map(function (k) {
        var meta = carePathsMeta[k] || {}; var rec = sub.tier === k;
        var cta = meta.url
          ? '<a class="ae-button ' + (rec ? 'ae-button--coral' : 'ae-button--ghost') + ' pha-care-cta" href="' + esc(meta.url) + '">Start ' + esc(meta.label || 'this plan') + '</a>'
          : '';
        return '<div class="pha-care-card" data-care-key="' + k + '" data-selected="' + (rec ? 'true' : 'false') + '" role="group" aria-label="' + esc(meta.label || k) + ' plan">' +
          (rec ? '<span class="pha-care-fit">Best fit for your pond</span>' : '') +
          '<div class="pha-care-top"><h5>' + esc(meta.label || k) + '</h5><span class="pha-care-price">' + esc(meta.price || '') +
          (meta.cadence ? ' <small class="pha-care-cadence">' + esc(meta.cadence) + '</small>' : '') + '</span></div>' +
          '<p>' + esc(meta.blurb || '') + '</p>' + cta + '</div>';
      }).join('');

      return '<div class="pha-report__section" data-sec-plan><h2 class="pha-r-h">Your A-eco Seasonal Care Plan</h2>' +
        '<p class="pha-r-sub">A preventative, EasyPro-focused plan' + (sub.season ? ' tuned for ' + esc(sub.season) : '') + '. It never includes test kits or fish medication — testing is how you start, not something you subscribe to.</p>' +
        '<div class="pha-block">' + intro +
        '<ul class="pha-plan-list" data-plan-list>' + items + '</ul>' +
        '<p class="pha-plan-note">' + esc(sub.note) + ' Every item shows why it’s included and can be removed. Prices and availability come from our store.</p>' +
        '<p class="pha-tiers-lead">Start the plan that matches your pond. Billed quarterly, cancel anytime:</p><div class="pha-care-paths" data-care-paths>' + tiers + '</div>' +
        '<p class="pha-plan-email-lead">Not ready to start today? Email yourself this plan and come back to it.</p>' +
        '<label class="pha-field pha-wide"><span>Email (we\'ll send this plan to you)</span><input name="planEmail" type="email" autocomplete="email" placeholder="you@example.com"></label>' +
        '<label class="pha-field pha-wide"><span>Name (optional)</span><input name="planName" type="text" autocomplete="name"></label>' +
        '<label class="pha-choice"><input type="checkbox" name="planConsent" value="Yes"><span>I understand this is preliminary pond guidance based on what I shared, that it is not a fish-health diagnosis, and that A-eco may follow up to confirm measurements before any final product fit.</span></label>' +
        '<button type="button" class="ae-button ae-button--ghost" data-submit-plan>Email me this plan</button>' +
        '<p class="pha-form-status" data-plan-status role="status"></p></div></div>';
    }

    // ---- Report interactions ----
    function wireReport() {
      report.querySelectorAll('[data-remove-plan]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var key = btn.getAttribute('data-remove-plan');
          var item = report.querySelector('[data-plan-key="' + key + '"]');
          var isRemoved = item.getAttribute('data-removed') === 'true';
          item.setAttribute('data-removed', isRemoved ? 'false' : 'true');
          removedPlan[key] = !isRemoved;
          btn.textContent = isRemoved ? 'Remove from plan' : 'Add back';
        });
      });
      report.querySelectorAll('[data-care-key]').forEach(function (card) {
        var pick = function () {
          selectedPath = card.dataset.careKey;
          report.querySelectorAll('[data-care-key]').forEach(function (c) { var on = c === card; c.dataset.selected = on ? 'true' : 'false'; });
        };
        // Selecting a tier is a preference, not navigation. Never swallow the plan link.
        card.addEventListener('click', function (e) {
          if (e.target.closest('.pha-care-cta')) return;
          pick();
        });
      });
      report.querySelectorAll('[data-goto]').forEach(function (a) {
        a.addEventListener('click', function (e) {
          e.preventDefault();
          var sec = a.getAttribute('data-goto') === 'plan' ? '[data-sec-plan]' : '[data-sec-reco]';
          var el = report.querySelector(sec); if (el) { setStage(a.getAttribute('data-goto') === 'plan' ? 5 : 4); el.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
        });
      });
      var restart = report.querySelector('[data-restart]');
      if (restart) restart.addEventListener('click', function () { form.reset(); lastReport = null; removedPlan = {}; showStep(1); });
      var edit = report.querySelector('[data-edit]');
      if (edit) edit.addEventListener('click', function () { showStep(2); });
      var submit = report.querySelector('[data-submit-plan]');
      if (submit) submit.addEventListener('click', submitPlan);
      // update stage as sections scroll into view
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (!en.isIntersecting) return;
            var map = { 'pha-report__section': null };
            if (en.target.hasAttribute('data-sec-analysis')) setStage(3);
            else if (en.target.hasAttribute('data-sec-reco')) setStage(4);
            else if (en.target.hasAttribute('data-sec-plan')) setStage(5);
          });
        }, { rootMargin: '-45% 0px -45% 0px' });
        report.querySelectorAll('[data-sec-analysis],[data-sec-reco],[data-sec-plan]').forEach(function (el) { io.observe(el); });
      }
    }

    // ---- Email the plan to the visitor. Not a purchase, not a waitlist. Prevents duplicates. ----
    function submitPlan() {
      if (submitting) return;
      var status = report.querySelector('[data-plan-status]');
      var emailEl = report.querySelector('input[name="planEmail"]');
      var consentEl = report.querySelector('input[name="planConsent"]');
      var email = emailEl ? emailEl.value.trim() : '';
      if (!email || !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) { status.textContent = 'Please enter a valid email so we can send your plan.'; return; }
      if (!consentEl || !consentEl.checked) { status.textContent = 'Please confirm you understand this is preliminary guidance, not a diagnosis.'; return; }
      var sub = lastReport.subscription || { components: [] };
      var planItems = sub.components.filter(function (c) { return !removedPlan[c.category.key]; })
        .map(function (c) { return { category: c.category.key, label: c.category.label, cadence: c.cadence }; });
      if (!endpoint) { status.textContent = 'Your plan is ready above. (Email delivery isn’t configured on this preview.)'; return; }
      submitting = true; status.textContent = 'Sending your plan…';
      var meta = carePathsMeta[selectedPath] || {};
      var payload = {
        source: 'A-eco Pond Health Advisor', email: email,
        name: (report.querySelector('input[name="planName"]') || {}).value || '',
        subscriptionTier: selectedPath, subscriptionTierLabel: meta.label || selectedPath,
        subscriptionSeason: sub.season || null, subscriptionPlan: planItems,
        subscriptionExcludes: sub.excludes || ['test-kit', 'medications'],
        pondGallons: lastReport.gallons, score: lastReport.score.overall, confidence: lastReport.confidence.level,
        flags: lastReport.analysis.flags, urgent: lastReport.urgency.urgent,
        input: lastInput, timestamp: new Date().toISOString(), page: window.location.href
      };
      fetch(endpoint, { method: 'POST', mode: 'cors', headers: { 'Content-Type': 'text/plain;charset=utf-8' }, body: JSON.stringify(payload) })
        .then(function (res) { return res.text().then(function (txt) { return { ok: res.ok, txt: txt }; }); })
        .then(function (o) {
          var result = o.txt ? (function () { try { return JSON.parse(o.txt); } catch (e) { return { ok: true }; } })() : { ok: true };
          if (!o.ok || result.ok === false) throw new Error('not confirmed');
          status.textContent = 'Your plan is on its way to your inbox. Ready when you are — pick a plan above to start.';
        })
        .catch(function () { submitting = false; status.textContent = 'We couldn’t send that just now. Your plan is still shown above — please try again, or email us.'; });
    }

    updateGallonsReadout();
    setStage(1);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:request', async (event) => {
    if (window.CART_REDIRECTION_ENABLED) {
      return; 
    }

    // Cancel default cart addition processing
    event.preventDefault();

    try {
      // Convert FormData to array format (expected by AddToCartFlyout)
      const formData = event.detail.form;
      const formDataArray = [];
      for (let [key, value] of formData.entries()) {
        formDataArray.push({ name: key, value: value });
      }

      const submitButton = document.querySelector('button[type="submit"], input[type="submit"]');
      
        const addToCartFlyout = new window.AddToCartFlyout(formDataArray, {
          atcButton: submitButton,
          settings: {
            moneyFormat: window.SHOP_MONEY_FORMAT
          }
        });

        // Wait for AddToCartFlyout completion and return actual response data
        const handleComplete = (completeEvent) => {
          document.removeEventListener('addToCartFlyout:complete', handleComplete);
          document.removeEventListener('addToCartFlyout:error', handleError);
          event.detail.resolve(completeEvent.detail.responseData);
        };

        const handleError = (errorEvent) => {
          document.removeEventListener('addToCartFlyout:complete', handleComplete);
          document.removeEventListener('addToCartFlyout:error', handleError);
          event.detail.reject(errorEvent.detail.error);
        };

        document.addEventListener('addToCartFlyout:complete', handleComplete);
        document.addEventListener('addToCartFlyout:error', handleError);

    } catch (error) {
      console.error('AddToCartFlyout error:', error);
      event.detail.reject(error);
    }
  });

  document.addEventListener('product-form:cart:navigate', (event) => {
    if (!window.CART_REDIRECTION_ENABLED) {
      event.preventDefault();
    }
  });

  document.addEventListener('product-form:submit:success', (event) => {
    if (window.CART_REDIRECTION_ENABLED) {
      window.location.href = window.Theme.routes.cart_url;
    }
  });

  } catch(e) { console.error(e); }
})();
})();
